import { attr } from '@ember-data/model';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export default EmberDataBaseModel.extend({
  nameKey: attr('string'),
  name: attr('string'),
  description: attr('string'),
  rank: attr('number')
}).reopenClass({
  _modelNameForMigration: 'apps/partner-application-category'
});